import React from "react";
import { default as MUIMenuItem } from "@mui/material/MenuItem";
import styled from "styled-components";

const StyledMUIMenuItem = styled(MUIMenuItem)``;

export const MenuItem = (props) => {
  return <StyledMUIMenuItem {...props} />;
};
